import { render, staticRenderFns } from "./UpdateShipTimeDialog.vue?vue&type=template&id=8b65675a&"
import script from "./UpdateShipTimeDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateShipTimeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports